import { render, staticRenderFns } from "./batchdetail.vue?vue&type=template&id=c72ab2b6&scoped=true&"
import script from "./batchdetail.vue?vue&type=script&lang=js&"
export * from "./batchdetail.vue?vue&type=script&lang=js&"
import style0 from "./batchdetail.vue?vue&type=style&index=0&id=c72ab2b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72ab2b6",
  null
  
)

export default component.exports